var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.classes
  }, [(_vm.status != 'default') ? _c('span', {
    staticClass: "Polaris-VisuallyHidden"
  }, [_vm._v("\n        " + _vm._s(_vm.status.charAt(0).toUpperCase() + _vm.status.slice(1)) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f247658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f247658","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisBadge.vue
// module id = 165
// module chunks = 0